import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, X } from "@phosphor-icons/react";
import api from "../../lib/api";
import { NumberField } from "./DailyReportForm";
import { apiError, btnGhost, countryLabel, inp } from "./util";

export function useBatches(includeArchived = false, q = "") {
    const [data, setData] = useState({ countries: [], items: [] });
    const [tick, setTick] = useState(0);
    useEffect(() => {
        api.get("/reporting/po-batches", { params: { include_archived: includeArchived, q } })
            .then(({ data }) => setData(data))
            .catch(async (e) => toast.error(await apiError(e)));
    }, [includeArchived, q, tick]);
    return [data, () => setTick((t) => t + 1)];
}

function BatchPicker({ value, onChange, exclude }) {
    const [archived, setArchived] = useState(false);
    const [q, setQ] = useState("");
    const [{ items }] = useBatches(archived, q);
    const opts = items.filter((b) => b.id === value || !exclude.includes(b.id));
    return (
        <div className="space-y-1">
            {archived && <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari batch arsip" className={inp} data-testid="batch-search-input" />}
            <select value={value} onChange={(e) => onChange(e.target.value)} className={inp} data-testid="batch-select">
                <option value="">Pilih batch PO…</option>
                {opts.map((b) => <option key={b.id} value={b.id}>{b.name} · {countryLabel(b.country)}{b.archived ? " (arsip)" : ""}</option>)}
            </select>
            <label className="text-[11px] text-neutral-500 inline-flex items-center gap-1">
                <input type="checkbox" checked={archived} onChange={(e) => setArchived(e.target.checked)} data-testid="batch-archived-toggle" /> Sertakan batch arsip
            </label>
        </div>
    );
}

export default function PoRows({ rows, onChange, fields, disabled }) {
    const set = (i, patch) => onChange(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)));
    const blank = Object.fromEntries([["batch_id", ""], ...fields.map(([k]) => [k, 0])]);
    return (
        <div className="space-y-3" data-testid="po-rows">
            {rows.map((r, i) => (
                <div key={i} className="border border-mist rounded-sm p-3 bg-white space-y-3" data-testid={`po-row-${i}`}>
                    <div className="flex gap-2 items-start">
                        <div className="flex-1"><BatchPicker value={r.batch_id} onChange={(v) => set(i, { batch_id: v })} exclude={rows.map((x) => x.batch_id)} /></div>
                        {!disabled && <button type="button" onClick={() => onChange(rows.filter((_, j) => j !== i))} className="text-neutral-400 hover:text-red-600 pt-2" data-testid={`po-row-remove-${i}`}><X size={16} /></button>}
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {fields.map(([k, label, type, hint]) => <NumberField key={k} k={`po-${i}-${k}`} label={label} type={type} hint={hint} value={r[k]} onChange={(_, v) => set(i, { [k]: v })} />)}
                    </div>
                </div>
            ))}
            {!disabled && <button type="button" onClick={() => onChange([...rows, blank])} className={btnGhost} data-testid="po-row-add"><Plus size={14} /> Tambah batch PO</button>}
        </div>
    );
}
